import axios from 'axios'
import { URL, apiToken } from './global.env'

const apiClient = axios.create({
  baseURL: URL,
  withCredentials: false,
  headers: {
    'api-token': apiToken
  }
})

export default {
  getTierPrizeQuestions () {
    return apiClient({
      method: 'get',
      url: '/api/v1/tier-prize-questions/',
      headers: {
        'api-token': apiToken
      }
    })
  },
  createTierPrizeQuestions (data) {
    return apiClient({
      method: 'post',
      data: data,
      url: '/api/v1/tier-prize-questions/',
      headers: {
        'api-token': apiToken
      }
    })
  },
  editTierPrizeQuestions (id, data) {
    return apiClient({
      method: 'patch',
      data: data,
      url: `/api/v1/tier-prize-questions/${id}/`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  deleteTierPrizeQuestions (id) {
    return apiClient({
      method: 'delete',
      url: `/api/v1/tier-prize-questions/${id}/`,
      headers: {
        'api-token': apiToken
      }
    })
  }
}
